// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ecebc695","455":"8be3f1c8","977":"39c5ba2e"}[chunkId] + ".chunk.js";
};